import PanelController from "./panel-controller";

export default class extends PanelController {}